'use strict';

/*
gs.component('fieldImageStorage', {
    templateUrl: '',
    link: function(DI) {
        DI.prop('type');
        DI.prop('value', function(value) {});
        var setter = DI.prop('result', fn, {setter: true});
        setter(value);
    }
});
*/

(function() {
    if(!window.gs) {
        window.gs = {};
    }
    var util = angular.module('gymsystem.util');

    window.gs.component = function(name, option) {
        var modules = ['$rootScope', '$http', 'alertProvider', 'fileManager', '$parse', '$controller', '$filter', 'server', '$timeout', '$location', '$q', 'live', 'util', '$modal', 'Data', '$translate', '$injector', 'Link', 'formatter'];
        var staffModules = ['paymentMethods', 'showreport', 'workoutProvider', 'Setting'];

        util.directive(name, ['$rootScope', '$injector', function($rootScope, $injector) {
            function DI() {}

            function loadModules(list) {
                var moduleName;
                for(var i=0;i<list.length;i++) {
                    moduleName = list[i];
                    DI.prototype[moduleName] = $injector.get(moduleName);
                }
            }

            DI.prototype.get = function(moduleName) {
                return $injector.get(moduleName);
            };

            loadModules(modules);
            if($rootScope.getMember) {loadModules(staffModules);}

            return {
                scope: {},
                restrict: 'AE',
                template: option.template,
                templateUrl: option.templateUrl,
                controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
                    var di = new DI();
                    di.$scope = $scope;
                    di.$element = $element;
                    di.$attrs = $attrs;
                    var $parentScope = $scope.$parent;
                    di.$parentScope = $parentScope;
                    di.prop = function(attrName, fn, option) {
                        if(Array.isArray(attrName)) {
                            return attrName.forEach(function(attrName) {
                                di.prop(attrName);
                            });
                        }
                        option = option || {};
                        var attrValue = $attrs[attrName];
                        if(attrValue) {
                            $parentScope.$watch(attrValue, function(value) {
                                if(fn) {
                                    fn(value);
                                } else {
                                    $scope[attrName] = value;
                                }
                            });
                            if(option.setter) {
                                var setter = di.$parse(attrValue);
                                return function(value) {
                                    setter.assign($parentScope, value);
                                };
                            }
                        }
                    };

                    option.link.call($scope, di);
                }]
            };
        }]);

        
    };

    util.directive('fieldForm', [function() {
        return {
            transclude: true,
            scope: true,
            template: '<div class="col-sm-12"><div class="panel panel-{{type}}"><div class="panel-body" ng-transclude></div></div></div>',
            controller: ['$scope', '$attrs', function($scope, $attrs) {
                $scope.type = $attrs.type==null?'default':$attrs.type;
            }]
        };
    }]);

    util.directive('fieldFormInjector', ['$compile', function($compile) {
        return {
            link: function($scope, $element) {
                var field = $scope.field;
                if(!field.field) {return;}
                var option = $scope.field.option || {};
                if(field.title) {
                    option.title = field.title;
                }
                $scope.__option = function(key) {
                    return option[key];
                };
                var html = '<field-' + field.field + '-no-frame value="field.value"';
                for(var k in option) {
                    var attrName = k.replace(/[A-Z]/g, function(a) {return '-' + a.toLowerCase();});
                    html += ' ' + attrName + '="__option(\'' + k + '\')"';
                }
                html += '></field-' + field.field + '-no-frame>';
                var tag = angular.element(html);
                var compiled = $compile(tag)($scope);
                $element.replaceWith(compiled);
            }
        };
    }]);

})();
